import React, { createContext, useContext, useEffect, useState } from 'react'

interface AdminModeContextType {
  adminMode: boolean
  setAdminMode: (value: boolean) => void
  initialized: boolean
}

const AdminModeContext = createContext<AdminModeContextType | undefined>(undefined)

export const AdminModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [adminMode, setAdminModeState] = useState<boolean>(false)
  const [initialized, setInitialized] = useState<boolean>(false)

  useEffect(() => {
    const stored = localStorage.getItem('adminMode')
    if (stored === 'true') setAdminModeState(true)
    setInitialized(true)
  }, [])

  const setAdminMode = (value: boolean) => {
    setAdminModeState(value)
    localStorage.setItem('adminMode', String(value))
  }

  return (
    <AdminModeContext.Provider value={{ adminMode, setAdminMode, initialized }}>
      {children}
    </AdminModeContext.Provider>
  )
}

export const useAdminMode = (): AdminModeContextType => {
  const context = useContext(AdminModeContext)
  if (context === undefined) {
    throw new Error('useAdminMode must be used within an AdminModeProvider')
  }
  return context
}
